import {Component, OnInit} from '@angular/core';
import {AppService} from '../app.service';
declare let $: any;
declare let window: any;
declare let paypal: any;

@Component({
  selector: 'location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css', '../app.component.css']
})
export class LocationComponent implements OnInit {
  citySearch = "";
  stateList = [
    {state: "Alabama", abbrev: "AL"},
    {state: "Alaska", abbrev: "AK"},
    {state: "Arizona", abbrev: "AZ"},
    {state: "Arkansas", abbrev: "AR"},
    {state: "California", abbrev: "CA"},
    {state: "Colorado", abbrev: "CO"},
    {state: "Connecticut", abbrev: "CT"},
    {state: "Delaware", abbrev: "DE"},
    {state: "District of Columbia", abbrev: "DC"},
    {state: "Florida", abbrev: "FL"},
    {state: "Georgia", abbrev: "GA"},
    {state: "Hawaii", abbrev: "HI"},
    {state: "Idaho", abbrev: "ID"},
    {state: "Illinois", abbrev: "IL"},
    {state: "Indiana", abbrev: "IN"},
    {state: "Iowa", abbrev: "IA"},
    {state: "Kansas", abbrev: "KS"},
    {state: "Kentucky", abbrev: "KY"},
    {state: "Louisiana", abbrev: "LA"},
    {state: "Maine", abbrev: "ME"},
    {state: "Maryland", abbrev: "MD"},
    {state: "Massachusetts", abbrev: "MA"},
    {state: "Michigan", abbrev: "MI"},
    {state: "Minnesota", abbrev: "MN"},
    {state: "Mississippi", abbrev: "MS"},
    {state: "Missouri", abbrev: "MO"},
    {state: "Montana", abbrev: "MT"},
    {state: "Nebraska", abbrev: "NE"},
    {state: "Nevada", abbrev: "NV"},
    {state: "New Hampshire", abbrev: "NH"},
    {state: "New Jersey", abbrev: "NJ"},
    {state: "New Mexico", abbrev: "NM"},
    {state: "New York", abbrev: "NY"},
    {state: "North Carolina", abbrev: "NC"},
    {state: "North Dakota", abbrev: "ND"},
    {state: "Ohio", abbrev: "OH"},
    {state: "Oklahoma", abbrev: "OK"},
    {state: "Oregon", abbrev: "OR"},
    {state: "Pennsylvania", abbrev: "PA"},
    {state: "Rhode Island", abbrev: "RI"},
    {state: "South Carolina", abbrev: "SC"},
    {state: "South Dakota", abbrev: "SD"},
    {state: "Tennessee", abbrev: "TN"},
    {state: "Texas", abbrev: "TX"},
    {state: "Utah", abbrev: "UT"},
    {state: "Vermont", abbrev: "VT"},
    {state: "Virginia", abbrev: "VA"},
    {state: "Washington", abbrev: "WA"},
    {state: "West Virginia", abbrev: "WV"},
    {state: "Wisconsin", abbrev: "WI"},
    {state: "Wyoming", abbrev: "WY"}
  ];
  tempSelectedStates = [];
  selSelectedStates = [];

  cityList = [];
  tempSelectedCities = [];
  selSelectedCities = [];

  searchTimeout = null;
  savedCardDefer = null;

  locationSaved = true;
  locationTextDotCount = 0;
  locationSaveText = "Updating";
  locationIncrementer = null;

  constructor(public app: AppService) {

  }

  ngOnInit() {
    console.log("Location init");

    this.updateWithSelCardInfo();
    this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
  }


  filterLocationsChange(val, forceScroll = true, inInit = false) {
    console.log("Filter location change: ", val);
    if (inInit) {
      if (this.app.filterLocations) {
        this.animateOp("locPanel", 315, 1);
      } else {
        this.animateOp("locPanel", 0, 0);
      }
      return;
    }
    if (this.app.filterLocations !== val) {
      this.app.cardAdChanged = true;
      setTimeout(() => {
        this.prepSaveCardChanges();
      }, 500);
    }
    if (!val) {
      this.animateOp("locPanel", 0, 0);
      setTimeout(() => {
        this.app.filterLocations = val;
      }, 1000);
    } else {
      this.app.filterLocations = val;
      this.animateOp("locPanel", 315, 1);
      if (forceScroll) {
        setTimeout(() => {
          window.scrollTo(0, document.getElementById("locationSection").offsetTop);
        }, 300);
      }
    }
  }

  searchCities() {
    console.log("Search timeout init");
    if (this.searchTimeout !== null) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    this.searchTimeout = setTimeout(() => {
      this.runSearch();
    }, 1000);
  }

  runSearch() {
    console.log("Running search", this.citySearch);
    this.searchTimeout = null;
    this.app.mapSearch(this.citySearch).subscribe((data: any) => {
      console.log("Map search data: ", data);
      this.cityList = data;
    }, (error) => {
      console.log("Error: ", error);
    });
  }

  animateOp(op, height, opacity) {
    $('#' + op + '').animate({
      height: '' + height,
      opacity: '0' + opacity
    });
  }

  addSelStates() {
    if (this.tempSelectedStates.length > 0) {
      this.app.cardAdChanged = true;
      setTimeout(() => {
        this.prepSaveCardChanges();
      }, 500);
    }
    console.log("Temp sel states: ", this.tempSelectedStates);
    this.tempSelectedStates.forEach((s) => {
      this.app.selectedStates.push(s);
      let i = this.stateList.findIndex((s2: any) => {
        return s2.state === s.state;
      });
      this.stateList.splice(i, 1);
    });
    this.tempSelectedStates = [];
  }

  removeSelStates() {
    if (this.selSelectedStates.length > 0) {
      this.app.cardAdChanged = true;
      setTimeout(() => {
        this.prepSaveCardChanges();
      }, 500);
    }
      this.selSelectedStates.forEach((s) => {
        this.stateList.push(s);
        let i = this.app.selectedStates.findIndex((s2: any) => {
          return s2.state === s.state;
        });
        this.app.selectedStates.splice(i, 1);
      });
      this.selSelectedStates = [];
      this.sortStates();
  }

  sortStates() {
    this.stateList = this.stateList.sort((a,b) => {
      if (a.state === b.state) {
        return 0;
      } else if (a.state > b.state) {
        return 1;
      } else
        return -1;
    });
  }

  addCitiesClicked() {
    let alreadySelected = [];
    if (this.tempSelectedCities.length > 0) {
      this.app.cardAdChanged = true;
      setTimeout(() => {
        this.prepSaveCardChanges();
      }, 500);
    }
    this.tempSelectedCities.forEach((c) => {
      if (!this.checkCityAlreadySelected(c)) {
        console.log("City being added: ", this.app.selectedCities, c);
        c.radius = 50;
        this.app.selectedCities.push(c);
      } else {
        console.log("Already selected");
        alreadySelected.push(c);
      }
    });
    this.tempSelectedCities = alreadySelected;
  }

  removeCities() {
    if (this.selSelectedCities.length > 0) {
      this.app.cardAdChanged = true;
      setTimeout(() => {
        this.prepSaveCardChanges();
      }, 500);
    }
    this.app.selectedCities = this.app.selectedCities.filter((c) => {
      return !this.selSelectedCities.find((d) => {
        return (d.city === c.city) && (d.state === c.state);
      });
    });
    this.selSelectedCities = [];
  }

  checkCityAlreadySelected(city) {
    return this.app.selectedCities.some((c) => {
      return ((c.city === city.city) && (c.state === city.state));
    });
  }

  cityClicked(city) {
    city.selected = !city.selected;
    if (city.selected) {
      this.selSelectedCities.push(city);
    } else {
      this.selSelectedCities = this.selSelectedCities.filter((c) => {
        if (c.state === city.state) {

        }
        return (c.city !== city.city || c.state !== city.state);
      });
    }
  }

  doesCardShowAnywhere(card) {
    console.log("Card anywhere? ", card);
    if (!card.locations) {
      let loc = {
        level: 4, //0 = None, 1 = Zip, 2 = City, 3 = State, 4 = National
        text: '',
        extra: '',
        latitude: 0.0,
        longitude: 0.0,
        radius: 0
      };
      card.locations = [];
      card.locations.push(loc);
      this.prepSaveCardChanges();
      return false;
    }
    if (card.locations.length === 0) {
      let loc = {
        level: 4, //0 = None, 1 = Zip, 2 = City, 3 = State, 4 = National
        text: '',
        extra: '',
        latitude: 0.0,
        longitude: 0.0,
        radius: 0
      };
      card.locations = [];
      card.locations.push(loc);
      this.prepSaveCardChanges();
      return false;
    }
    if (card.locations.length === 1) {
      if (card.locations[0].level === 4) {
        return false;
      }
    }
    return true;
  }

  updateWithSelCardInfo() {
    console.log("Updating with sel card info: ", this.app.selectedSavedCard);
    this.app.filterLocations = this.doesCardShowAnywhere(this.app.selectedSavedCard);
    console.log("Filter locations? ", this.app.filterLocations);
    if (this.app.selectedStates.length > 0) {
      this.app.selectedStates.forEach((s) => {
        this.stateList.push(s);
      });
      this.sortStates();
      this.app.selectedStates = [];
    }
    this.app.selectedCities = [];
    setTimeout(() => {
      this.filterLocationsChange(true, false, true);
    });
    this.app.impressionCount = 10;
    this.app.selectedSavedCard.locations.forEach((l) => {
      switch(l.level) {
        case 2:
          let city = {city: l.text, state: l.extra, latitude: l.latitude, longitude: l.longitude, radius: l.radius};
          this.app.selectedCities.push(city);
          break;
        case 3:
          let state = this.stateList.find((s) => {
            return s.abbrev === l.text;
          });
          if (state != null) {
            this.stateList = this.stateList.filter((s) => {
              return s.abbrev !== state.abbrev;
            });
            this.app.selectedStates.push(state);
          }
          break;
        default:
          break;
      }
    });
  }

  prepSaveCardChanges() {
    if (this.savedCardDefer !== null) {
      clearTimeout(this.savedCardDefer);
      this.savedCardDefer = null;
    }
    this.locationSaved = false;
    this.locationIncrementer = setInterval(() => {
      if (this.locationTextDotCount >= 3) {
        this.locationTextDotCount = 0;
        this.locationSaveText = "Updating";
      } else {
        this.locationSaveText = this.locationSaveText + ".";
        this.locationTextDotCount++;
      }
    }, 300);
    this.savedCardDefer = setTimeout(() => {
      this.saveCardChanges();
    }, 1000);
  }

  saveCardChanges() {
    this.app.cardAdChanged = false;
    let loc = {
      level: 0, //0 = None, 1 = Zip, 2 = City, 3 = State, 4 = National
      text: '',
      extra: '',
      latitude: 0.0,
      longitude: 0.0,
      radius: 0
    };
    let locations = [];
    if (this.app.filterLocations && (this.app.selectedStates.length > 0 || this.app.selectedCities.length > 0)) {
      if (this.app.selectedStates.length === 51) { //All states selected
        loc.level = 4;
        locations.push(loc);
      } else {
        this.app.selectedCities.forEach((city) => {
          let c = this.app.createClone(loc);
          c.text = city.city;
          c.extra = city.abbrev;
          c.latitude = city.latitude;
          c.longitude = city.longitude;
          c.radius = city.radius;
          c.level = 2;
          locations.push(c);
        });
        this.app.selectedStates.forEach((state) => {
          let c = this.app.createClone(loc);
          c.level = 3;
          c.text = state.abbrev;
          locations.push(c);
        });
      }
    } else {
      loc.level = 4;
      locations.push(loc);
    }
    console.log("Locations: ", locations);
    setTimeout(() => {
      this.app.selectedSavedCard.locations = locations;
    });
    this.app.updateCardLocation(this.app.selectedSavedCard.id, this.app.getSessionID(), locations).subscribe((data) => {
      console.log("Saved location data: ", data);
      clearInterval(this.locationIncrementer);
      this.locationSaved = true;
    }, (error) => {
      console.log("Error saving card location: ", error);
    });
  }

  broadCastHandle(value: Object): void {
    switch(value['event']) {
      case 'selCardChanged':
        this.updateWithSelCardInfo();
        break;
      default:
        break;
    }
  }
}
